import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Models
import mDevice from 'models/device';
// Custom
import { cpmDeviceDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';

const CarparkDeviceStatusItem = ({ device }) => {
  const status = mDevice.status(device, false);

  return (
    <InformationItem
      icon={status.icon}
      iconColor={status.color}
      label={<LocalizedMessage id="field.status" />}
      value={<LocalizedMessage id={`device.timeout.${device.timeout}`} />}
      gender="male"
    />
  );
};

CarparkDeviceStatusItem.propTypes = {
  device: cpmDeviceDataShape.isRequired,
};

module.exports = CarparkDeviceStatusItem;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/main/CarparkDeviceStatusItem.js